import styled from 'styled-components';

const RoleAssignmentWrapper = styled.div`
  .page-header-wrapper {
    padding: 20px 15px;
  }

  .page-title {
    color: #101828;
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    margin: 0;
  }

  .info-alert {
    margin-bottom: 20px;
    border-radius: 8px;
  }

  .main-card {
    border: 1px solid #eaecf0;
    box-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06);
    border-radius: 12px;

    .ant-card-head-title {
      color: #101828;
      font-weight: 600;
      font-size: 16px;
    }
  }

  .role-card {
    margin-bottom: 16px;
    border: 1px solid #eaecf0;
    border-radius: 8px;

    .ant-card-head {
      background-color: #f9fafb;
      border-bottom: 1px solid #eaecf0;
    }

    .role-header {
      display: flex;
      align-items: center;
      gap: 12px;

      .anticon {
        font-size: 18px;
        color: #0B2A1B;
      }

      .role-title {
        font-weight: 500;
        font-size: 16px;
        color: #101828;
      }
    }

    .role-description {
      color: #667085;
      margin-bottom: 16px;
      font-size: 14px;
      font-style: italic;
      line-height: 20px;
    }
  }

  .ant-form-item-label > label {
    color: #344054;
    font-weight: 500;
    font-size: 14px;
  }

  .user-select {
    .ant-select-selector {
      border-radius: 8px;
      border-color: #d0d5dd;
    }

    &.ant-select-focused .ant-select-selector {
      border-color: #0B2A1B;
      box-shadow: 0 0 0 2px rgba(11, 42, 27, 0.1);
    }

    &:hover .ant-select-selector {
      border-color: #0B2A1B;
    }
  }

  .current-assignments {
    margin-top: 16px;
    padding: 16px;
    background-color: #f9fafb;
    border-radius: 8px;
    border: 1px solid #eaecf0;

    .assignments-label {
      font-weight: 500;
      margin-bottom: 12px;
      color: #101828;
      font-size: 14px;
    }

    .ant-list-item {
      padding: 12px 0;
      border-bottom: 1px solid #eaecf0;

      &:last-child {
        border-bottom: none;
      }
    }

    .ant-list-item-meta-title {
      color: #101828;
      font-weight: 500;
    }

    .ant-list-item-meta-description {
      color: #667085;
    }
  }

  .save-button {
    background-color: #0B2A1B;
    border-color: #0B2A1B;
    font-weight: 600;
    border-radius: 8px;
    height: 44px;
    width: 100%;
  }

  .save-button:hover,
  .save-button:focus {
    background-color: #0d3521;
    border-color: #0d3521;
  }

  .save-button:active {
    background-color: #092116;
    border-color: #092116;
  }

  .ant-select-selection-item {
    display: flex;
    align-items: center;
    background-color: #f9fafb;
    border: 1px solid #d0d5dd;
    border-radius: 4px;
  }

  .ant-tag {
    border-radius: 6px;
    font-weight: 500;
  }

  /* Loading spinner */
  .ant-spin-dot-item {
    background-color: #0B2A1B;
  }

  .ant-select-selector {
    height: auto;
  }

  /* Responsive */
  @media only screen and (max-width: 768px) {
    .page-header-wrapper {
      padding: 15px 10px;
    }

    .page-title {
      font-size: 16px;
    }

    .role-card {
      .role-header {
        flex-direction: row;
        gap: 8px;

        .role-title {
          font-size: 14px;
        }
      }
    }
  }
`;

export default RoleAssignmentWrapper;
